import api from '../../api';
import { ComposicaoDisponibilidade, ComposicaoTemplates } from '../../model/banca/ComposicaoDisponibilidade';

export class ComposicaoDisponibilidadeViewModel {
    static async getComposicaoDisponibilidade(processoId: string, bancaId: string): Promise<ComposicaoTemplates> {
        const response = await api.get<ComposicaoTemplates>(
            `/processos/${processoId}/bancas/${bancaId}/composicao-disponibilidade`
        );
        return response.data;
    }

    static async getComposicaoDefinicao(processoId: string, bancaId: string): Promise<ComposicaoTemplates> {
        const response = await api.get<ComposicaoTemplates>(
            `/processos/${processoId}/bancas/${bancaId}/composicao-definicao`
        );
        return response.data;
    }
}
